import { Route } from 'react-router-dom';
import Page from './../../components/Page';
import Contacts from './Contacts';
import Contact from './Contact';
import NewContact from './NewContact';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import { observer } from 'mobx-react-lite';

const ContactsTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.CONTACTS}>
                <Contacts store={store} />
            </Route>
            <Route exact path={Paths.CONTACT}>
                <Contact store={store} />
            </Route>
            <Route exact path={Paths.NEW_CONTACT}>
                <NewContact store={store} />
            </Route>
        </Page>
    );
};

export default observer(ContactsTab);
